import Firebase from "./firebase";
import { AuthProvider, withFirebaseHOC } from "./authContext";

export default Firebase;

export { AuthProvider, withFirebaseHOC };
